module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee-4-36c0bde70e9e54ac6d9f8a8dd239ed3e.png";